export default __webpack_public_path__ + "static/media/46t.5f4a2460.jpg";